import FullScreen from "~Components/layout/fullScreen"
import React from "react"
import { Redirect, Route, RouteProps } from "react-router-dom"
import { LocalStorageService } from "~Shared/services"

export const FullScreenRoute = (props: RouteProps) => (
    <Route {...props}>{(routeProps) => <FullScreen>{typeof props.children === "function" ? props.children(routeProps) : props.children}</FullScreen>}</Route>
)

export const PrivateFullScreen = (props: RouteProps) =>
    LocalStorageService.isAuthorized() ? (
        <Route {...props}>{(routeProps) => <FullScreen>{typeof props.children === "function" ? props.children(routeProps) : props.children}</FullScreen>}</Route>
    ) : (
        <Redirect to={{ pathname: "/login", state: { from: props.path } }} />
    )
